export enum FitroomAvatarSex {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
}

export enum FitroomCoverageLevel {
  MAXIMUM = 'MAXIMUM',
  MINIMAL = 'MINIMAL',
  MODERATE = 'MODERATE',
}

export enum FitroomSkinTone {
  BROWN_0 = 'BROWN_0',
  BROWN_1 = 'BROWN_1',
  BROWN_2 = 'BROWN_2',
  BROWN_3 = 'BROWN_3',
  BROWN_4 = 'BROWN_4',
  BROWN_5 = 'BROWN_5',
  BROWN_6 = 'BROWN_6',
  BROWN_7 = 'BROWN_7',
  BROWN_8 = 'BROWN_8',
  BROWN_9 = 'BROWN_9',
  BLACK = 'BLACK',
  GRAY = 'GRAY',
  WHITE = 'WHITE',
}

export enum FitroomMessageType {
  APP_LOADED_EVENT = 'fitroom.app.loaded.evt',
  AVATAR_FROM_SMPL_REQ = 'fitroom.avatar.smpl.req',
  AVATAR_FROM_STAR_REQ = 'fitroom.avatar.star.req',
  CREDENTIALS_REQ = 'fitroom.credentials.req',
  CREDENTIALS_RES = 'fitroom.credentials.res',
  GARMENT_REQ = 'fitroom.garment.req',
  GARMENT_SKU_REQ = 'fitroom.garment.sku.req',
  GARMENT_UPDATED_EVENT = 'fitroom.garment.updated.evt',
  SESSION_REQ = 'fitroom.session.req',
  SESSION_RES = 'fitroom.session.res',
}

// Payload types.

export type FitroomCredentialsResPayload = {
  appKey: string;
  origin?: string;
};

export type FitroomAvatarFromSmplReqPayload = {
  sex: FitroomAvatarSex;
  smplShape: number[];
};

export type FitroomAvatarFromStarReqPayload = {
  sex: FitroomAvatarSex;
  starShape: number[];
};

export type FitroomGarmentReqPayload = {
  id: string;
  isSizeRecommendation?: boolean;
};

export type FitroomSessionResPayload = {
  avatarDisplayCovBottom?: FitroomCoverageLevel;
  avatarDisplayCovTop?: FitroomCoverageLevel;
  avatarDisplaySkin?: FitroomSkinTone;
  avatarId?: string;
  poseId?: string;
};

// Message types.

export type FitroomAppLoadedEvent = {
  type: FitroomMessageType.APP_LOADED_EVENT;
};

export type FitroomAvatarFromSmplReq = {
  type: FitroomMessageType.AVATAR_FROM_SMPL_REQ;
  payload: FitroomAvatarFromSmplReqPayload;
};

export type FitroomAvatarFromStarReq = {
  type: FitroomMessageType.AVATAR_FROM_STAR_REQ;
  payload: FitroomAvatarFromStarReqPayload;
};

export type FitroomCredentialsReq = {
  type: FitroomMessageType.CREDENTIALS_REQ;
};

export type FitroomCredentialsRes = {
  type: FitroomMessageType.CREDENTIALS_RES;
  payload: FitroomCredentialsResPayload;
};

export type FitroomGarmentReq = {
  type: FitroomMessageType.GARMENT_REQ;
  payload: FitroomGarmentReqPayload;
};

export type FitroomGarmentSkuReq = {
  type: FitroomMessageType.GARMENT_SKU_REQ;
  payload: string;
};

export type FitroomGarmentUpdatedEvent = {
  type: FitroomMessageType.GARMENT_UPDATED_EVENT;
  payload: string;
};

export type FitroomSessionReq = {
  type: FitroomMessageType.SESSION_REQ;
  payload: string;
};

export type FitroomSessionRes = {
  type: FitroomMessageType.SESSION_RES;
  payload: FitroomSessionResPayload;
};

type Unrecognized = {
  type: string;
};

export type FitroomMessageIncoming =
  | FitroomAppLoadedEvent
  | FitroomCredentialsReq
  | FitroomGarmentUpdatedEvent
  | FitroomSessionRes
  | Unrecognized;

export type FitroomMessageOutgoing =
  | FitroomAvatarFromSmplReq
  | FitroomAvatarFromStarReq
  | FitroomCredentialsRes
  | FitroomGarmentReq
  | FitroomGarmentSkuReq
  | FitroomSessionReq;

export type FitroomMessage = FitroomMessageIncoming | FitroomMessageOutgoing;
